import { Button } from 'reactstrap';

import ModalBase from '../ModalBase/ModalBase';

export function DisableChapterModal({ isOpen, toggle, onDisabledClick }) {
  const handleDisable = () => {
    onDisabledClick();
    toggle();
  };

  return (
    <ModalBase
      isOpen={isOpen}
      toggle={toggle}
      header={<>Are you sure you want to disable this chapter?</>}
      body={
        <>
          Disabling a chapter will remove its questions from all study methods.
          You can re-enable it at any time.
        </>
      }
      footer={
        <>
          <Button className="btn modal-base-btn secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button
            className="btn modal-base-btn primary"
            onClick={handleDisable}
          >
            Disable
          </Button>
        </>
      }
    />
  );
}
